"use strict";

exports.__esModule = true;
exports.default = sample;
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _values = _interopRequireDefault(require("./values.js"));
var _getLength = _interopRequireDefault(require("./_getLength.js"));
var _random = _interopRequireDefault(require("./random.js"));
var _toArray = _interopRequireDefault(require("./toArray.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Sample **n** random values from a collection using the modern version of the
// [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `_.map`.
function sample(obj, n, guard) {
  if (n == null || guard) {
    if (!(0, _isArrayLike.default)(obj)) obj = (0, _values.default)(obj);
    return obj[(0, _random.default)(obj.length - 1)];
  }
  var sample = (0, _toArray.default)(obj);
  var length = (0, _getLength.default)(sample);
  n = Math.max(Math.min(n, length), 0);
  var last = length - 1;
  for (var index = 0; index < n; index++) {
    var rand = (0, _random.default)(index, last);
    var temp = sample[index];
    sample[index] = sample[rand];
    sample[rand] = temp;
  }
  return sample.slice(0, n);
}